import { Component } from "react";
import App from '../../AppContainer/container/app_container';
import { ConfigProvider } from 'antd';
import { IntlProvider } from 'react-intl'
import lang_de from '../../../language/de'
import lang_en from '../../../language/en'

export interface LocalProps{
  id:string
  language:string
}

interface LanguageViewInnerState{language:string;}

export class LanguageProviderContainer extends Component<LocalProps, LanguageViewInnerState> 
  {


  onSubmit = (data:any)  => {
    console.log(data);
  }


  messages :any = {
    'de-DE': lang_de,
    'en-EN': lang_en
};


render(){
  return (
    <IntlProvider locale={this.props.language} messages={this.messages[this.props.language]}>
      <ConfigProvider direction="ltr">
        <App id={"App"}/>
      </ConfigProvider>
    </IntlProvider>
    )
  }
};

